__turbopack_context__.v({
  "list-item": "table-of-contents-module-scss-module__ZTPA2q__list-item",
  "list-item--subsection": "table-of-contents-module-scss-module__ZTPA2q__list-item--subsection",
  "table-of-contents": "table-of-contents-module-scss-module__ZTPA2q__table-of-contents",
  "table-of-contents--fixed-on-scroll": "table-of-contents-module-scss-module__ZTPA2q__table-of-contents--fixed-on-scroll",
  "table-of-contents--sidebar": "table-of-contents-module-scss-module__ZTPA2q__table-of-contents--sidebar",
});
